// Picks use nicknames; the scoreboard uses full names (e.g. Green Bay Packers).
export const matchesPick = (team, pick) => Boolean(pick) &&
  (team?.name === pick || team?.name?.endsWith(` ${pick}`));

export function excludedTeams(picks, games, teams) {
  const excluded = new Set(picks);
  games.forEach(game => {
    for (const [selected, opponent] of [[game.home, game.away], [game.away, game.home]]) {
      if (picks.some(pick => matchesPick(selected, pick))) {
        teams.filter(team => matchesPick(opponent, team)).forEach(team => excluded.add(team));
      }
    }
  });
  return excluded;
}
